import React from "react";
import { IconProps } from "..";

export default (props: IconProps) => (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m12.983 12 8.813-8.814a.694.694 0 1 0-.983-.982L12 11.017 3.186 2.204a.694.694 0 1 0-.982.982L11.017 12l-8.813 8.814a.695.695 0 1 0 .982.983L12 12.983l8.813 8.814a.693.693 0 0 0 .983 0 .695.695 0 0 0 0-.983L12.983 12z"
            fill="#000"
            fillRule="evenodd"
        />
    </svg>
);
